import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'react-toolbox/lib/font_icon';

const LocationBlock = ({
  isRemote,
  location = {},
  showIcon = true,
  style,
}) => {
  // don't render anything if there is no location data or it is a remote event
  const { latitude, longitude, ...restLocation } = location;
  const locationValues = Object.values(restLocation);
  if (
    isRemote ||
    (locationValues.length && locationValues.every(value => value === null))
  ) {
    return null;
  }

  const {
    name,
    addressLine1,
    addressLine2,
    city,
    stateAbbreviation,
    postalCode,
  } = location;

  const displayLocation = {
    name,
    addressLine1,
    addressLine2,
    cityStateZip: `${city}, ${stateAbbreviation} ${postalCode}`
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        ...style,
      }}
    >
      {showIcon && (
        <FontIcon
          value="location_on"
          style={{
            marginRight: '4px',
            backgroundColor: 'transparent',
            color: '#00AD50'
          }}
        />
      )}
      <div>
        {Object.keys(displayLocation).map(key => {
          return <div key={key}>{displayLocation[key]}</div>;
        })}
      </div>
    </div>
  );
};

LocationBlock.propTypes = {
  location: PropTypes.object,
  color: PropTypes.string,
  showIcon: PropTypes.bool,
};

export default LocationBlock;



// WEBPACK FOOTER //
// ./src/App/events/components/LocationBlock.js